import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.classes),
    style: {"position":"fixed","top":"8%","width":"98%","left":"0","z-index":"99999999","margin":"1%"}
  }, _toDisplayString(_ctx.message), 3))
}